import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import { Hue, Saturation, EditableInput } from 'react-color/lib/components/common';
import { ColorPalette } from '@theme-ui/style-guide';
import Color from 'color';
import tinycolor from 'tinycolor2';
import { CustomPicker, GithubPicker } from 'react-color';
import { usePopoverState, Popover, PopoverDisclosure } from 'reakit/Popover';
import React, { createContext, useContext, useEffect, forwardRef, useState, useRef, Fragment } from 'react';
import { useThemeUI, jsx, ThemeProvider } from 'theme-ui';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var EditorContext = createContext(null);

var useEditor = function useEditor() {
  var themeui = useThemeUI();
  var editor = useContext(EditorContext);
  return editor || themeui;
};

var theme = {
  colors: {
    primary: 'hsl(210, 100%, 40%)',
    highlight: 'hsl(210, 50%, 95%)'
  }
};

var Editor = function Editor(_ref) {
  var context = _ref.context,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 16 : _ref$fontSize,
      color = _ref.color,
      bg = _ref.bg,
      props = _objectWithoutProperties(_ref, ["context", "fontSize", "color", "bg"]);

  var outer = useThemeUI();
  context = context || outer;
  return jsx(EditorContext.Provider, {
    value: context
  }, jsx(ThemeProvider, {
    scoped: true,
    theme: theme
  }, jsx("div", _extends({}, props, {
    sx: {
      fontFamily: 'system-ui, sans-serif',
      fontSize: fontSize,
      lineHeight: 1.5,
      fontWeight: 400,
      color: color,
      bg: bg
    }
  }))));
};

var round = function round(n) {
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Math.floor(n * Math.pow(10, x)) / Math.pow(10, x);
};

var Lens = function Lens(props) {
  return jsx("div", {
    sx: {
      width: 16,
      height: 16,
      borderRadius: 9999,
      border: '1px solid white',
      transform: 'translate(-8px, -8px)'
    }
  });
};

var Handle = function Handle(props) {
  return jsx("div", {
    sx: {
      width: 12,
      height: 12,
      borderRadius: 9999,
      backgroundColor: 'white',
      boxShadow: '0 0 2px rgba(0,0,0,.25)',
      transform: 'translate(-6px, -2px)'
    }
  });
};
/** placeholder is used because react-color does not pass
 * HTML attributes to the element
 */


var Input = function Input(props) {
  return jsx(EditableInput, _extends({}, props, {
    placeholder: props.name,
    style: {
      input: {
        width: '100%',
        fontSize: 12,
        fontFamily: 'Menlo, monospace',
        margin: 0,
        padding: 0,
        border: 0,
        outline: 'none'
      },
      label: {
        display: 'none'
      }
    }
  }));
};

var Label = function Label(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      props = _objectWithoutProperties(_ref, ["width", "flex"]);

  return jsx("label", _extends({}, props, {
    sx: {
      display: 'block',
      width: width,
      fontSize: 10,
      input: {
        ':focus': {
          color: 'primary',
          bg: 'highlight'
        }
      }
    }
  }));
};

var Picker = CustomPicker(function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 256 : _ref2$size,
      props = _objectWithoutProperties(_ref2, ["size"]);

  return jsx("div", {
    sx: {
      display: 'grid',
      p: 2,
      gridGap: 2,
      width: size,
      borderRadius: 4,
      bg: 'white',
      boxShadow: '0 2px 8px 1px rgba(0,0,0,.125)'
    }
  }, jsx("div", {
    sx: {
      position: 'relative',
      width: '100%',
      height: 0,
      paddingBottom: '75%'
    }
  }, jsx(Saturation, _extends({}, props, {
    pointer: Lens
  }))), jsx("div", {
    sx: {
      position: 'relative',
      width: '100%',
      height: 8
    }
  }, jsx(Hue, _extends({}, props, {
    pointer: Handle
  }))), jsx("div", {
    sx: {
      display: 'flex'
    }
  }, jsx(Label, null, "Hex", jsx(Input, _extends({}, props, {
    value: props.hex,
    name: "hex",
    label: "hex",
    onChange: function onChange(val) {
      props.onChange(val);
    }
  }))), jsx(Label, null, "Hue", jsx(Input, _extends({}, props, {
    value: round(props.hsl.h),
    name: "hue",
    label: "h",
    onChange: function onChange(val) {
      props.onChange(_objectSpread2({}, props.hsl, {}, val));
    }
  }))), jsx(Label, null, "Saturation", jsx(Input, _extends({}, props, {
    value: round(props.hsl.s * 100),
    name: "saturation",
    label: "s",
    onChange: function onChange(_ref3) {
      var s = _ref3.s;
      props.onChange(_objectSpread2({}, props.hsl, {
        s: s / 100
      }));
    }
  }))), jsx(Label, null, "Lightness", jsx(Input, _extends({}, props, {
    value: round(props.hsl.l * 100),
    name: "lightness",
    label: "l",
    onChange: function onChange(_ref4) {
      var l = _ref4.l;
      props.onChange(_objectSpread2({}, props.hsl, {
        l: l / 100
      }));
    }
  })))));
});

var ColorPicker = function ColorPicker(_ref5) {
  var _children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["children"]);

  var popover = usePopoverState();
  var hasChildren = !!_children;

  if (!hasChildren) {
    return jsx(Picker, props);
  }

  return jsx(React.Fragment, null, jsx(PopoverDisclosure, _extends({}, popover, {
    children: function children(disclosure) {
      return jsx("div", disclosure, _children);
    }
  })), jsx(Popover, _extends({}, popover, {
    "aria-label": "Edit color",
    sx: {
      outline: 'none'
    }
  }), jsx(Picker, props)));
};

var ColorPalette$1 = function ColorPalette$1(props) {
  var context = useEditor();
  var mode = context.colorMode;
  var _context$theme$colors = context.theme.colors,
      colors = _context$theme$colors === void 0 ? {} : _context$theme$colors;

  var onChange = function onChange(key) {
    return function (val) {
      var next = {};

      if (mode && colors.modes && colors.modes[mode] && mode !== context.theme.initialColorMode) {
        next = {
          colors: {
            modes: _defineProperty({}, mode, _defineProperty({}, key, val.hex))
          }
        };
      } else {
        next = {
          colors: _defineProperty({}, key, val.hex)
        };
      }

      context.setTheme(next);
    };
  };

  return jsx(ThemeProvider, {
    theme: {
      colors: colors
    }
  }, jsx(ColorPalette, _extends({}, props, {
    mode: mode,
    render: function render(_ref) {
      var swatch = _ref.swatch,
          color = _ref.color,
          key = _ref.key,
          rest = _objectWithoutProperties(_ref, ["swatch", "color", "key"]);

      return jsx(ColorPicker, {
        key: key,
        color: color,
        onChange: onChange(key)
      }, swatch);
    }
  })));
};

var Label$1 = function Label(props) {
  return jsx("label", _extends({}, props, {
    sx: {
      display: 'block',
      fontSize: 0,
      fontWeight: 'bold'
    }
  }));
};

var Chevron = function Chevron(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 12 : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return jsx("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    sx: {
      pointerEvents: 'none'
    }
  }), jsx("path", {
    stroke: "currentcolor",
    strokeWidth: "2",
    fill: "none",
    d: "M14 6 L8 12 L2 6"
  }));
};

var Select = function Select(props) {
  return jsx("div", {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, jsx("select", _extends({}, props, {
    sx: _objectSpread2({
      appearance: 'none',
      width: '100%',
      height: 32,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      p: 1,
      m: 0,
      color: 'black',
      bg: 'white',
      border: '1px solid',
      borderColor: 'lightgray',
      ':focus': {
        borderColor: 'primary',
        outline: 'none'
      },
      variant: '@theme-ui/editor.select'
    }, props.sx)
  })), jsx(Chevron, {
    sx: {
      ml: '-24px'
    }
  }));
};

var ColorMode = function ColorMode(props) {
  var context = useEditor();
  var theme = context.theme,
      colorMode = context.colorMode,
      setColorMode = context.setColorMode;

  var _ref = theme.colors || {},
      _ref$modes = _ref.modes,
      modes = _ref$modes === void 0 ? {} : _ref$modes;

  var keys = [theme.initialColorMode || 'default'].concat(_toConsumableArray(Object.keys(modes)));
  return jsx("div", null, jsx(Label$1, {
    htmlFor: "color-mode"
  }, "Color Mode"), jsx(Select, {
    id: "color-mode",
    name: "color-mode",
    value: colorMode,
    onChange: function onChange(e) {
      var mode = e.target.value;
      setColorMode(mode);
    }
  }, keys.map(function (key) {
    return jsx("option", {
      key: key,
      children: key
    });
  })));
};

var Input$1 = forwardRef(function (props, ref) {
  return jsx("input", _extends({
    ref: ref
  }, props, {
    sx: _objectSpread2({
      appearance: 'none',
      width: '100%',
      height: 32,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      p: 1,
      m: 0,
      color: 'black',
      bg: 'white',
      border: '1px solid',
      borderColor: 'lightgray',
      ':focus': {
        borderColor: 'primary',
        outline: 'none'
      },
      variant: '@theme-ui/editor.input'
    }, props.sx)
  }));
});

var noop = function noop() {};

var Field = function Field(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      label = _ref.label,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "label", "name", "onChange", "className"]);

  return jsx("div", {
    className: className
  }, jsx(Label$1, {
    htmlFor: name
  }, label || name), jsx(Input$1, _extends({}, props, {
    type: type,
    id: name,
    name: name,
    onChange: function onChange(e) {
      _onChange(e.target.value);
    }
  })));
};

var defaultSpace = [0, 4, 8, 16, 32, 64, 128, 256, 512];

var Space = function Space(props) {
  var context = useEditor();
  var _context$theme$space = context.theme.space,
      space = _context$theme$space === void 0 ? defaultSpace : _context$theme$space;

  var onChange = function onChange(key) {
    return function (val) {
      var n = parseFloat(val);

      if (Array.isArray(space)) {
        var i = parseInt(key);
        context.setTheme({
          space: [].concat(_toConsumableArray(space.slice(0, i)), [n], _toConsumableArray(space.slice(i + 1)))
        });
      } else {
        context.setTheme({
          space: _defineProperty({}, key, n)
        });
      }
    };
  };

  return Object.keys(space).map(function (key) {
    return jsx("div", {
      key: key
    }, jsx(Field, {
      type: "number",
      label: key,
      name: 'space.' + key,
      value: space[key],
      onChange: onChange(key)
    }));
  });
};

var keys = {
  38: 'up',
  40: 'down',
  27: 'escape',
  13: 'return'
};

var Combobox = function Combobox(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      props = _objectWithoutProperties(_ref, ["type", "name", "label", "value", "onChange", "options"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      index = _useState4[0],
      setIndex = _useState4[1];

  var root = useRef(null);
  var input = useRef(null);
  useEffect(function () {
    var handleOutsideClick = function handleOutsideClick(e) {
      if (root.current && root.current.contains(e.target)) {
        return;
      }

      setOpen(false);
    };

    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [root.current]);
  useEffect(function () {
    resetIndex();
  }, [value]);
  var popup = name + '-popup';

  var resetIndex = function resetIndex() {
    var i = options.indexOf(value);
    setIndex(i);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey) {
      return;
    }

    switch (keys[e.keyCode]) {
      case 'up':
        if (!open) {
          setOpen(true);
        }

        if (index < 1) {
          setIndex(options.length - 1);
        } else {
          setIndex(index - 1);
        }

        break;

      case 'down':
        if (!open) {
          setOpen(true);
        }

        setIndex((index + 1) % options.length);
        break;

      case 'return':
        if (!open) {
          return;
        }

        var val = options[index];

        if (val) {
          onChange(val);
        }

        setOpen(false);
        break;

      case 'escape':
        setOpen(false);
        resetIndex();
        break;
    }
  };

  var handleChange = function handleChange(e) {
    onChange(e.target.value);
  };

  var handleBlur = function handleBlur(e) {
    requestAnimationFrame(function () {
      if (root.current.contains(document.activeElement)) {
        return;
      }

      setOpen(false);
    });
  };

  var toggleOpen = function toggleOpen(e) {
    setOpen(!open);

    if (input.current) {
      input.current.focus();
    }
  };

  var handleItemClick = function handleItemClick(i) {
    return function (e) {
      var val = options[i];

      if (val) {
        onChange(val);
      }

      setOpen(false);
      input.current.select();
    };
  };

  return jsx("div", {
    ref: root,
    style: {
      position: open ? 'relative' : 'static'
    },
    sx: {
      zIndex: 2,
      color: 'black'
    }
  }, jsx(Label$1, {
    htmlFor: name
  }, label || name), jsx("div", {
    sx: {
      display: 'flex'
    }
  }, jsx(Input$1, _extends({}, props, {
    ref: input,
    role: "combobox",
    type: type,
    id: name,
    name: name,
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    "aria-autocomplete": "none",
    "aria-haspopup": "true",
    "aria-owns": popup,
    "aria-expanded": open,
    "aria-activedescendant": name + index
  })), jsx("button", {
    tabIndex: "-1",
    "aria-label": open ? 'Close' : 'Open',
    onClick: toggleOpen,
    sx: {
      appearance: 'none',
      width: 32,
      height: 32,
      color: 'inherit',
      bg: 'transparent',
      border: 0,
      ml: -32
    }
  }, jsx(Chevron, null))), jsx("ul", {
    id: popup,
    role: "listbox",
    "aria-label": name,
    tabIndex: "-1",
    style: {
      visibility: open ? 'visible' : 'hidden',
      position: open ? 'absolute' : 'static'
    },
    sx: {
      left: 0,
      right: 0,
      top: '100%',
      listStyle: 'none',
      p: 0,
      m: 0,
      maxHeight: 512,
      overflowY: 'auto',
      bg: 'white',
      border: '1px solid',
      borderTop: 0,
      borderColor: 'lightgray'
    }
  }, open && options.map(function (option, i) {
    return jsx("li", {
      key: option,
      role: "option",
      "aria-selected": i === index,
      onClick: handleItemClick(i),
      sx: {
        p: 1,
        userSelect: 'none',
        '&[aria-selected=true],:hover': {
          bg: 'highlight'
        }
      }
    }, option);
  })));
};

var defaultFonts = ['system-ui, sans-serif', '"Helvetica Neue", Helvetica, Arial, sans-serif', '"Avenir Next", Helvetica, Arial, sans-serif', 'Verdana, sans-serif', 'Georgia, serif', 'Inter, sans-serif', 'Roboto, sans-serif', '"Roboto Condensed", sans-serif', '"Roboto Mono", monospace', '"Roboto Slab", serif', '"Open Sans", sans-serif', 'Lato, sans-serif', 'Montserrat, sans-serif', '"Source Sans Pro", sans-serif', '"Source Serif Pro", serif', '"Source Code Pro", monospace', '"Raleway", sans-serif', '"Oswald", sans-serif', '"Merriweather", serif', 'Menlo, monospace'];

var Fonts = function Fonts(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? defaultFonts : _ref$options,
      props = _objectWithoutProperties(_ref, ["options"]);

  var context = useEditor();
  var _context$theme$fonts = context.theme.fonts,
      fonts = _context$theme$fonts === void 0 ? {} : _context$theme$fonts;

  var onChange = function onChange(key) {
    return function (val) {
      context.setTheme({
        fonts: _defineProperty({}, key, val)
      });
    };
  };

  return Object.keys(fonts).map(function (key) {
    return jsx("div", {
      key: key
    }, jsx(Combobox, {
      label: key,
      name: 'fonts.' + key,
      value: fonts[key],
      onChange: onChange(key),
      options: options
    }));
  });
};

var weights = [100, 200, 300, 400, 500, 600, 700, 800, 900];

var FontWeights = function FontWeights(props) {
  var context = useEditor();
  var _context$theme$fontWe = context.theme.fontWeights,
      fontWeights = _context$theme$fontWe === void 0 ? {} : _context$theme$fontWe;

  var onChange = function onChange(key) {
    return function (val) {
      context.setTheme({
        fontWeights: _defineProperty({}, key, val)
      });
    };
  };

  return Object.keys(fontWeights).map(function (key) {
    return jsx("div", {
      key: key
    }, jsx(Combobox, {
      label: key,
      name: 'fontWeights.' + key,
      value: fontWeights[key],
      onChange: onChange(key),
      options: weights
    }));
  });
};

var LineHeights = function LineHeights(props) {
  var context = useEditor();
  var _context$theme$lineHe = context.theme.lineHeights,
      lineHeights = _context$theme$lineHe === void 0 ? {} : _context$theme$lineHe;

  var onChange = function onChange(key) {
    return function (val) {
      var n = parseFloat(val);
      context.setTheme({
        lineHeights: _defineProperty({}, key, n)
      });
    };
  };

  return Object.keys(lineHeights).map(function (key) {
    return jsx("div", {
      key: key
    }, jsx(Field, {
      type: "number",
      label: key,
      name: 'lineHeights.' + key,
      value: lineHeights[key],
      onChange: onChange(key),
      min: 1,
      max: 3,
      step: 1 / 64
    }));
  });
};

var FontSizes = function FontSizes(props) {
  var context = useEditor();
  var _context$theme$fontSi = context.theme.fontSizes,
      fontSizes = _context$theme$fontSi === void 0 ? [] : _context$theme$fontSi;

  var onChange = function onChange(key) {
    return function (val) {
      var n = parseFloat(val);

      if (Array.isArray(fontSizes)) {
        var i = parseInt(key);
        context.setTheme({
          fontSizes: [].concat(_toConsumableArray(fontSizes.slice(0, i)), [n], _toConsumableArray(fontSizes.slice(i + 1)))
        });
      } else {
        context.setTheme({
          fontSizes: _defineProperty({}, key, n)
        });
      }
    };
  };

  return Object.keys(fontSizes).map(function (key) {
    return jsx("div", {
      key: key
    }, jsx(Field, {
      type: "number",
      label: key,
      name: 'fontSizes.' + key,
      value: fontSizes[key],
      onChange: onChange(key)
    }));
  });
};

var Row = function Row(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 64 : _ref$width,
      props = _objectWithoutProperties(_ref, ["width"]);

  return jsx("div", _extends({}, props, {
    sx: {
      display: 'grid',
      gridGap: 2,
      gridTemplateColumns: "repeat(auto-fit, minmax(".concat(width, "px, 1fr))")
    }
  }));
};

var flattenObject = function flattenObject(object) {
  var result = {};

  function flatten(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];

      if (_typeof(value) === 'object') {
        flatten(value, "".concat(prefix).concat(key, "."));
      } else {
        result["".concat(prefix).concat(key)] = value;
      }
    });
  }

  flatten(object);
  return result;
};

var toHex = function toHex(raw) {
  try {
    return Color(raw).hex();
  } catch (e) {
    return raw;
  }
};

var Colors = function Colors(_ref) {
  var theme = _ref.theme,
      setTheme = _ref.setTheme;
  var colors = flattenObject(theme.colors);
  return jsx("section", null, jsx("h2", null, "Colors"), Object.keys(colors).map(function (key) {
    var value = colors[key];
    return jsx(ColorPicker, {
      key: key,
      color: toHex(value),
      onChange: function onChange(_ref2) {
        var hex = _ref2.hex;
        setTheme({
          colors: _defineProperty({}, key, hex)
        });
      }
    }, jsx("button", {
      key: key,
      title: "Edit color",
      sx: {
        appearance: 'none',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        px: 0,
        m: 0,
        py: 1,
        color: 'inherit',
        bg: 'transparent',
        border: 0,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
      }
    }, jsx("div", {
      sx: {
        width: 24,
        height: 24,
        mr: 2,
        bg: key,
        borderRadius: 9999,
        border: '1px solid',
        borderColor: 'muted'
      }
    }), jsx("div", {
      sx: {
        fontSize: 0
      }
    }, key)));
  }));
};

var Select$1 = function Select(props) {
  return jsx("select", _extends({}, props, {
    sx: {
      width: '100%'
    }
  }));
};

var Modes = function Modes(_ref) {
  var colorMode = _ref.colorMode,
      theme = _ref.theme,
      setColorMode = _ref.setColorMode;

  var _useState = useState(colorMode),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var modes = ['initial'].concat(_toConsumableArray(Object.keys(theme.colors.modes || {})));
  useEffect(function () {
    if (value) {
      setColorMode(value);
    }
  }, [value]);
  return jsx("section", null, jsx("h2", null, "Color Modes"), jsx("label", {
    htmlFor: "colormode"
  }, "Color Mode"), jsx(Select$1, {
    id: "colormode",
    name: "colormode",
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  }, modes.map(function (mode) {
    return jsx("option", {
      key: mode
    }, mode);
  })));
};

var Input$2 = function Input(props) {
  return jsx("input", _extends({}, props, {
    sx: {
      appearance: 'none',
      color: 'inherit',
      bg: 'transparent',
      border: '1px solid',
      borderRadius: 2,
      display: 'block',
      fontSize: 'inherit',
      fontFamily: 'inherit',
      p: 1,
      width: '100%'
    }
  }));
};

var Typography = function Typography(_ref) {
  var theme = _ref.theme,
      setTheme = _ref.setTheme;
  return jsx("section", null, jsx("h2", null, "Typography"), jsx("h3", null, "Fonts"), Object.keys(theme.fonts || {}).map(function (key) {
    return jsx("div", {
      key: key,
      sx: {
        mb: 2
      }
    }, jsx(Label$1, {
      htmlFor: key
    }, key), jsx(Input$2, {
      id: key,
      name: key,
      value: theme.fonts[key],
      onChange: function onChange(e) {
        setTheme({
          fonts: _defineProperty({}, key, e.target.value)
        });
      }
    }));
  }), jsx("h3", null, "Font Sizes"), Array.isArray(theme.fontSizes) ? theme.fontSizes.map(function (n, i) {
    return jsx("div", {
      key: i,
      sx: {
        mb: 2
      }
    }, jsx(Label$1, {
      htmlFor: "fontsize-".concat(i)
    }, "Font Size ", i), jsx(Input$2, {
      key: i,
      id: "fontsize-".concat(i),
      name: "fontsize-".concat(i),
      type: "number",
      value: n,
      onChange: function onChange(e) {
        var n = parseInt(e.target.value);
        setTheme({
          fontSizes: [].concat(_toConsumableArray(theme.fontSizes.slice(0, i)), [n], _toConsumableArray(theme.fontSizes.slice(i + 1)))
        });
      }
    }));
  }) : Object.keys(theme.fontSizes).map(function (key) {
    return jsx("div", {
      key: key,
      sx: {
        mb: 2
      }
    }, jsx(Label$1, {
      htmlFor: "fontSizes.".concat(key)
    }, "fontSizes.", key), jsx(Input$2, {
      id: "fontSizes.".concat(key),
      name: "fontSizes.".concat(key),
      type: "number",
      value: theme.fontSizes[key],
      onChange: function onChange(e) {
        var n = parseInt(e.target.value);
        setTheme({
          fontSizes: _defineProperty({}, key, n)
        });
      }
    }));
  }));
};

var ThemeColorPicker = function ThemeColorPicker(_ref) {
  var _children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["children", "theme"]);

  var popover = usePopoverState();
  var context = useEditor();

  var _ref2 = theme || context.theme,
      colors = _ref2.colors;

  var value = colors[props.value] || props.value;
  var options = ['transparent'].concat(_toConsumableArray(Object.keys(colors).map(function (key) {
    return colors[key];
  }).filter(function (color) {
    return typeof color === 'string';
  }).filter(function (color) {
    return /^#/.test(color);
  })));

  var onChange = function onChange(color) {
    var _ref3 = Object.entries(colors).find(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          v = _ref6[1];

      return tinycolor(v).toHexString() === color.hex;
    }) || [],
        _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    props.onChange(key || color.hex || color);
  };

  var onChangeComplete = function onChangeComplete() {
    popover.hide();
  };

  return jsx(React.Fragment, null, jsx(PopoverDisclosure, _extends({}, popover, {
    children: function children(disclosure) {
      return jsx("div", _extends({}, disclosure, {
        style: {
          backgroundColor: value
        },
        sx: {
          width: 32,
          height: 32,
          border: '1px solid',
          borderColor: 'lightgray'
        }
      }), _children);
    }
  })), jsx(Popover, _extends({}, popover, {
    "aria-label": "Choose Color",
    style: {
      zIndex: popover.visible ? 1 : null
    }
  }), jsx(GithubPicker, _extends({
    colors: options,
    triangle: "hide"
  }, props, {
    color: value,
    onChange: onChange,
    onChangeComplete: onChangeComplete
  }))));
};
/** @jsx jsx */


var SxColors = function SxColors(_ref) {
  var _ref$value = _ref.value;
  _ref$value = _ref$value === void 0 ? {} : _ref$value;
  var color = _ref$value.color,
      bg = _ref$value.bg,
      theme = _ref.theme,
      _onChange = _ref.onChange;
  return jsx("div", {
    sx: {
      display: 'grid',
      gridGap: 2,
      gridTemplateColumns: 'repeat(2, 1fr)',
      my: 3
    }
  }, jsx("div", {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, jsx(ThemeColorPicker, {
    theme: theme,
    value: color || '',
    onChange: function onChange(color) {
      _onChange({
        color: color
      });
    }
  }), jsx("div", {
    sx: {
      fontWeight: 'bold',
      ml: 2
    }
  }, "Color")), jsx("div", {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, jsx(ThemeColorPicker, {
    theme: theme,
    value: bg || '',
    onChange: function onChange(bg) {
      _onChange({
        bg: bg
      });
    }
  }), jsx("div", {
    sx: {
      fontWeight: 'bold',
      ml: 2
    }
  }, "Background Color")));
};

var SxSpace = function SxSpace(_ref) {
  var tag = _ref.tag,
      _ref$property = _ref.property,
      property = _ref$property === void 0 ? 'margin' : _ref$property,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value,
      onChange = _ref.onChange;

  var _useState = useState({
    x: false,
    y: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      lock = _useState2[0],
      setLock = _useState2[1];

  var key = property === 'margin' ? 'm' : 'p';
  var x = value[key + 'x'] || value[property + 'X'] || '';
  var y = value[key + 'y'] || value[property + 'Y'] || '';
  var t = lock.y ? y : value[key + 't'] || value[property + 'Top'] || '';
  var b = lock.y ? y : value[key + 'b'] || value[property + 'Bottom'] || '';
  var l = lock.x ? x : value[key + 'l'] || value[property + 'Left'] || '';
  var r = lock.x ? x : value[key + 'r'] || value[property + 'Right'] || '';
  useEffect(function () {
    if (typeof x === 'number') {
      setLock(function (lock) {
        return _objectSpread2({}, lock, {
          x: true
        });
      });
    }

    if (typeof y === 'number') {
      setLock(function (lock) {
        return _objectSpread2({}, lock, {
          y: true
        });
      });
    }
  }, []);

  var handleChange = function handleChange(direction) {
    return function (n) {
      var val = n === '' ? undefined : parseInt(n);

      switch (direction) {
        case 't':
          if (lock.y) {
            onChange(_defineProperty({}, key + 'y', val));
          } else {
            onChange(_defineProperty({}, key + 't', val));
          }

          break;

        case 'b':
          if (lock.y) {
            onChange(_defineProperty({}, key + 'y', val));
          } else {
            onChange(_defineProperty({}, key + 'b', val));
          }

          break;

        case 'l':
          if (lock.x) {
            onChange(_defineProperty({}, key + 'x', val));
          } else {
            onChange(_defineProperty({}, key + 'l', val));
          }

          break;

        case 'r':
          if (lock.x) {
            onChange(_defineProperty({}, key + 'x', val));
          } else {
            onChange(_defineProperty({}, key + 'r', val));
          }

          break;
      }
    };
  };

  var onChangeLock = function onChangeLock(dir) {
    return function (e) {
      var isX = dir === 'x';

      if (!lock[dir]) {
        var _onChange9;

        setLock(function (lock) {
          return _objectSpread2({}, lock, _defineProperty({}, dir, true));
        });
        var val = isX ? l || r : t || b;
        onChange((_onChange9 = {}, _defineProperty(_onChange9, key + isX ? 'l' : 't', undefined), _defineProperty(_onChange9, key + isX ? 'r' : 'b', undefined), _defineProperty(_onChange9, key + dir, val), _onChange9));
      } else {
        var _onChange10;

        setLock(function (lock) {
          return _objectSpread2({}, lock, _defineProperty({}, dir, false));
        });

        var _val = dir === 'x' ? x : y;

        onChange((_onChange10 = {}, _defineProperty(_onChange10, key + isX ? 'l' : 't', undefined), _defineProperty(_onChange10, key + isX ? 'r' : 'b', undefined), _defineProperty(_onChange10, key + dir, _val), _onChange10));
      }
    };
  };

  var prefixName = function prefixName(name) {
    return tag ? "styles.".concat(tag, ".").concat(key).concat(name) : key + name;
  };

  var label = function label(dir) {
    return property === 'margin' ? 'Margin ' + dir : 'Padding ' + dir;
  };

  return jsx("div", {
    sx: {
      display: 'grid',
      gridGap: 2,
      gridTemplateColumns: 'repeat(3, 1fr)',
      alignItems: 'center'
    }
  }, jsx(Field, {
    type: "number",
    name: prefixName('l'),
    label: label("Left"),
    value: l,
    onChange: handleChange('l')
  }), jsx("div", {
    sx: {
      display: 'grid',
      gridGap: 2
    }
  }, jsx(Field, {
    type: "number",
    name: prefixName('t'),
    label: label("Top"),
    value: t,
    onChange: handleChange('t')
  }), jsx("div", null, jsx("label", null, jsx("input", {
    type: "checkbox",
    checked: lock.x,
    onChange: onChangeLock('x')
  }), "Lock x-axis"), jsx("label", null, jsx("input", {
    type: "checkbox",
    checked: lock.y,
    onChange: onChangeLock('y')
  }), "Lock y-axis")), jsx(Field, {
    type: "number",
    name: prefixName('b'),
    label: label("Bottom"),
    value: b,
    onChange: handleChange('b')
  })), jsx(Field, {
    type: "number",
    name: prefixName('r'),
    label: label("Right"),
    value: r,
    onChange: handleChange('r')
  }));
};

var SxTypography = function SxTypography(_ref) {
  var tag = _ref.tag,
      _ref$value = _ref.value;
  _ref$value = _ref$value === void 0 ? {} : _ref$value;
  var fontFamily = _ref$value.fontFamily,
      fontSize = _ref$value.fontSize,
      fontWeight = _ref$value.fontWeight,
      lineHeight = _ref$value.lineHeight,
      _ref$theme = _ref.theme;
  _ref$theme = _ref$theme === void 0 ? {} : _ref$theme;
  var _ref$theme$fonts = _ref$theme.fonts,
      fonts = _ref$theme$fonts === void 0 ? {} : _ref$theme$fonts,
      _ref$theme$fontWeight = _ref$theme.fontWeights,
      fontWeights = _ref$theme$fontWeight === void 0 ? {} : _ref$theme$fontWeight,
      _ref$theme$lineHeight = _ref$theme.lineHeights,
      lineHeights = _ref$theme$lineHeight === void 0 ? {} : _ref$theme$lineHeight,
      _onChange = _ref.onChange;

  var prefixName = function prefixName(name) {
    return tag ? "styles.".concat(tag, ".").concat(name) : name;
  };

  return jsx(Fragment, null, jsx(Combobox, {
    name: prefixName('fontFamily'),
    label: "Font Family",
    value: fontFamily || '',
    onChange: function onChange(fontFamily) {
      _onChange({
        fontFamily: fontFamily
      });
    },
    options: ['inherit'].concat(_toConsumableArray(Object.keys(fonts)))
  }), jsx("div", {
    sx: {
      display: 'grid',
      gridGap: 2,
      gridTemplateColumns: 'repeat(3, 1fr)'
    }
  }, jsx(Field, {
    name: prefixName('fontSize'),
    label: "Font Size",
    value: fontSize || '',
    type: "number",
    onChange: function onChange(val) {
      var fontSize = Number(val);

      _onChange({
        fontSize: fontSize
      });
    }
  }), jsx(Combobox, {
    name: prefixName('fontWeight'),
    label: "Font Weight",
    value: fontWeight || '',
    onChange: function onChange(fontWeight) {
      _onChange({
        fontWeight: fontWeight
      });
    },
    options: ['inherit'].concat(_toConsumableArray(Object.keys(fontWeights)))
  }), jsx(Combobox, {
    name: prefixName('lineHeight'),
    label: "Line Height",
    value: lineHeight || '',
    onChange: function onChange(lineHeight) {
      _onChange({
        lineHeight: lineHeight
      });
    },
    options: ['inherit'].concat(_toConsumableArray(Object.keys(lineHeights)))
  })));
};

var StylesForm = function StylesForm(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'root' : _ref$tag;
  var context = useEditor();
  var _context$theme$styles = context.theme.styles,
      styles = _context$theme$styles === void 0 ? {} : _context$theme$styles;
  var style = styles[tag] || {};

  var setStyle = function setStyle(next) {
    context.setTheme({
      styles: _defineProperty({}, tag, _objectSpread2({}, style, {}, next))
    });
  };

  return jsx(Fragment, null, jsx("b", null, "theme.styles.", tag), jsx(SxTypography, {
    value: style,
    onChange: setStyle,
    theme: context.theme
  }), jsx(SxSpace, {
    value: style,
    onChange: setStyle
  }), jsx(SxColors, {
    value: style,
    onChange: setStyle
  }));
};

var SxMargin = function SxMargin(props) {
  return jsx(SxSpace, _extends({}, props, {
    property: "margin"
  }));
};

var SxPadding = function SxPadding(props) {
  return jsx(SxSpace, _extends({}, props, {
    property: "padding"
  }));
};

export { Editor, ColorPicker, ColorPalette$1 as ColorPalette, ColorMode, Space, Fonts, FontWeights, LineHeights, FontSizes, Row, Colors, Modes, Typography, StylesForm, ThemeColorPicker, SxColors, SxSpace, SxMargin, SxPadding, SxTypography, EditorContext, useEditor };